<template>
  <span>
    <template v-for="(segment, i) in segments">
      <a v-if="segment.href" :key="i" :href="segment.href" :target="segment.target" :rel="segment.rel">{{ segment.text }}</a>
      <span v-else :key="i">{{ segment.text }}</span>
    </template>
  </span>
</template>

<script>
import { readinessSegments } from "@/utils/cvcMigrationPage";

// One readiness line from the server, with the VISP /ip-address reference as a
// link. Segments render as elements and text, never as html.
export default {
  name: "CvcMigrationReadinessText",
  props: {
    text: { type: String, default: "" },
  },
  computed: {
    segments () {
      return readinessSegments(this.text, process.env.VISP_ADMIN_URL);
    },
  },
};
</script>
